import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { Edit } from "react-feather";
import { FilePlus } from "react-feather";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";

//FORM
import UpdateEmpInfo from "./UpdateEmployeeInfoForm";

interface ModalProps {
  EmpNo: string;
}

const UpdateEmpInfoModal: React.FC<ModalProps> = ({ EmpNo }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <div className="d-flex justify-content-end">
        <Btn
          color="info"
          onClick={toggle}
          style={{ display: "flex", alignItems: "center", gap: "2px" }}
        >
          <Edit size={16} className="me-1" />
          Update Employment Information
        </Btn>
      </div>

      <Modal
        size="xl"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Employment Information</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Update the employee's employment information.
            </P>
          </ModalHeader>
          <UpdateEmpInfo EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default UpdateEmpInfoModal;
